module.exports = __webpack_public_path__ + "img/app-icon.dd1fca33.png";